import React from "react";
import Thumb from "../ui/Thumb";
import PriceAndShare from "./PriceAndShare";
import PortalQuotePricing from "../portal/PortalQuotePricing";
import chevronDownDarkIcon from "../../assets/icons/chevron-down-dark.svg";
import chevronUpGreyIcon from "../../assets/icons/chevron-up-grey.svg";

const AircraftCardActions = ({
    price,
    operatorCurrency,
    currency,
    isPortalPage = false,
    sharedPage = false,
    approvalRequested,
    thumbsStatus,
    updateThumbsStatus,
    showMovida = false,
    legId,
    aircraftId,
    tailNumber,
    onInfoClick,
    expanded = false,
    onFlightDetailsClick,
    isExpanded,
    minimal = false,
    portalOption,
}) => {
    return (
        <div className={`aircraft-card__actions-column ${expanded ? "aircraft-card__actions-column--expanded" : ""}`}>
            <div className="aircraft-card__actions-inner">
                {isPortalPage ? (
                    <PortalQuotePricing {...portalOption} />
                ) : !sharedPage ? (
                    <PriceAndShare
                        price={price}
                        operatorCurrency={operatorCurrency}
                        currency={currency}
                        expanded={expanded}
                        showMovida={showMovida}
                        sharedPage={sharedPage}
                        legId={legId}
                        aircraftId={aircraftId}
                        tailNumber={tailNumber}
                        onInfoClick={onInfoClick}
                        minimal={minimal}
                    />
                ) : (
                    <div className="aircraft-card__actions-buttons aircraft-card__actions-buttons--thumb">
                        {approvalRequested === "true" && (
                            <Thumb status={thumbsStatus} updateStatus={(status) => updateThumbsStatus(status)} />
                        )}
                    </div>
                )}
            </div>

            {/* Mobile Flight Details Button - outside price section */}
            {onFlightDetailsClick && (
                <div className="aircraft-card__flight-details aircraft-card__flight-details--mobile">
                    <button className="aircraft-card__flight-details-toggle" onClick={onFlightDetailsClick}>
                        <span className="aircraft-card__flight-details-label">Flight Details</span>
                        <img
                            src={isExpanded ? chevronUpGreyIcon : chevronDownDarkIcon}
                            alt=""
                            className="aircraft-card__flight-details-chevron"
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default AircraftCardActions;
